<template>
  <div class="wrappers">
    <div></div>
    <div class="box" v-for="(i, n) in msgData" :key="n">
      <div class="header">
        <div class="left" :style="i.type | typeStyle">
          <Icon type="md-person" v-if="i.type == 1" :size="18"></Icon>
          {{ i.name }}
          <!-- || i.detail.real_name -->
        </div>
        <!-- <div class="center" v-if="i.permsg">
        </div> -->
        <div>
          <Button @click="oppear(i)" type="success" v-if="i.oppear">{{
            i.oppear
            }}</Button>
        </div>
      </div>
      <div class="detail">
        <div class="edit" v-if="i.type == 1">
          <div>
            <Icon type="ios-person-outline" :size="18"></Icon><span>用户名：</span>{{
              i.detail.name
            }}
          </div>
          <div>
            <Icon type="ios-person-outline" :size="18"></Icon><span>姓名：</span>
            <Input :disabled="isEditNew" type="text" v-model="i.detail.real_name"></Input>
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>充值积分：</span>{{
              i.detail.recharge_integral
            }}
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>赠送积分：</span>
            {{ i.detail.given_integral }}
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>
              省市区：</span>
            <Select :disabled="isEditNew" v-model="i.detail.province_id" @on-change="getCity" clearable
              style="width:100px">
              <Option v-for="(ii, nn) in i.detail.provinceList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
            <Select :disabled="isEditNew" v-model="i.detail.city_id" @on-change="getArea" clearable style="width:100px">
              <Option v-for="(ii, nn) in i.detail.cityList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
            <Select :disabled="isEditNew" v-model="i.detail.area_id" @on-change="selectArea" clearable
              style="width:100px">
              <Option v-for="(ii, nn) in i.detail.areaList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>所属学校：</span>
            <Select :disabled="isEditNew" v-model="i.detail.campus_id" clearable style="width:200px">
              <Option v-for="(ii, nn) in campus_nameArr" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
            <!-- <Input
              type="text"
              v-model="i.detail.campus_name"
            ></Input> -->
          </div>

          <!-- <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>科目：</span>
            <Select :disabled="isEdit" v-model="i.detail.subjectArr" multiple style="width:260px">
                <Option v-for="(ii, nn) in i.detail.subjectList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
          </div> -->
          <!-- <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>课程：</span>
            <Select :disabled="isEdit" v-model="i.detail.curseArr" multiple style="width:260px">
                <Option v-for="(ii, nn) in i.detail.curseList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
          </div> -->
          <!-- <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>级别：</span>
             <Select :disabled="isEdit" v-model="i.detail.gradeArr" multiple style="width:260px">
                <Option v-for="(ii, nn) in i.detail.gradeList" :value="ii.id" :key="nn">{{ ii.name }}</Option>
            </Select>
          </div> -->
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>微信号：</span>
            <Input :disabled="isEditNew" type="text" v-model="i.detail.wechat"></Input>
          </div>

          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>支付宝号：</span><Input type="text" :disabled="isEditNew"
              v-model="i.detail.alipay"></Input>
          </div>
          <div>
            <div>微信收款码：<br><span style="color:#999;font-size:12px">可不填，需提现时再提交</span></div>
            <div class="demo-upload-list" v-for="(item, index) in upConfig.weixinUploadList" :key="index">
              <div class="uploadimg"><img :src="path + item.url"></div>
              <div class="demo-upload-list-cover">
                <Icon style="color: #000;" type="ios-trash-outline" @click.native="handleRemove('weixinUploadList')">
                </Icon>
              </div>
            </div>
            <div v-if="upConfig.weixinUploadList.length == 0" class="uploadimg">
              <Upload ref="weixinUpload" :show-upload-list="false" :before-upload="beforeUpload"
                :format="['jpg', 'jpeg', 'png']" :max-size="2048" type="drag" :disabled="isEditNew" action=""
                style="margin-left:20px; display: inline-block;width:100px;height:100px;">
                <div style="width: 100px;height:110px;">
                  <Icon style="color: #000;" type="ios-cloud-upload-outline" size="80"></Icon>
                </div>
              </Upload>
            </div>
          </div>
          <div style="">
            <div>支付宝收款码：<br><span style="color:#999;font-size:12px">可不填，需提现时再提交</span> </div>
            <div v-if="upConfig.payforUploadList.length > 0" class="demo-upload-list"
              v-for="(item, index) in upConfig.payforUploadList" :key="index">
              <div class="uploadimg"><img :src="path + item.url"></div>
              <div class="demo-upload-list-cover">
                <Icon style="color: #000;" type="ios-trash-outline" @click.native="handleRemove('payforUploadList')">
                </Icon>
              </div>
            </div>
            <div v-if="upConfig.payforUploadList.length == 0" class="uploadimg">
              <Upload ref="payforUpload" :show-upload-list="false" :before-upload="beforeUpload1"
                :format="['jpg', 'jpeg', 'png']" :max-size="2048" type="drag" :disabled="isEditNew" action=""
                style="margin-left:20px; display: inline-block;width:100px;height:100px;">
                <div style="width: 100px;height:110px;">
                  <Icon style="color: #000;" type="ios-cloud-upload-outline" size="80"></Icon>
                </div>
              </Upload>
            </div>
          </div>
          <!-- <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>银行：</span>
            <Input
              type="text"
              :disabled="isEdit"
              v-model="i.detail.bank_name"
            ></Input>
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>银行卡：</span>
              <Input
              type="text"
              :disabled="isEdit"
              v-model="i.detail.bank_no"
            ></Input>
          </div> -->
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>邮箱：</span>
            <Input type="text" :disabled="isEditNew" v-model="i.detail.email"></Input>
          </div>
          <div>
            <Icon type="ios-home-outline" :size="18"></Icon><span>手机号：</span><Input type="text" :disabled="isEditNew"
              v-model="i.detail.mobile"></Input>
          </div>
        </div>
        <div class="join" v-if="i.type == 2">
          <div>{{ i.detail.banji }}</div>
        </div>
        <div class="pwd" v-if="i.type == 3 && isPwd">
          <Row>
            <Col span="18">
            <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="100">
              <!-- <Form-item label="原密码" prop="old">
                  <Input type="text" v-model="formCustom.old" number></Input>
                  <span class="tips"></span>
                </Form-item> -->
              <Form-item label="原密码" prop="old_password">

                <Input type="password" v-model="formCustom.old_password"></Input>
                <span class="tips">密码应为8-16位，同时包含数字和字母</span>
              </Form-item>
              <Form-item label="新密码" prop="passwd">

                <Input type="password" v-model="formCustom.passwd"></Input>
                <span class="tips">密码应为8-16位，同时包含数字和字母</span>
              </Form-item>
              <Form-item label="确认密码" prop="passwdCheck">
                <Input type="password" v-model="formCustom.passwdCheck"></Input>
                <span class="tips">请再一次输入新密码</span>
              </Form-item>
              <Form-item>
                <Button type="success" @click="pwdSubmit('formCustom')">提交</Button>
                <Button @click="cancel('isPwd')" style="margin-left: 8px">取消</Button>
              </Form-item>
            </Form>
            </Col>
          </Row>
        </div>
        <div class="set" v-if="i.type == 4 && isSubpwd">
          <Row style="padding:20px;">
            <Col span="12">
            <Steps :current="current">
              <Step title="身份验证" content=""></Step>
              <Step title="设置密保问题" content=""></Step>
            </Steps>
            <Form ref="formQestion" :model="formQestion" :rules="ruleQestion" :label-width="100">
              <Form-item label="登录密码" prop="subPwd" v-if="current == 0">
                <Input type="text" v-model="formQestion.subPwd" number></Input>
                <span class="tips"></span>
              </Form-item>
            </Form>
            <Form ref="formSecret" :model="formSecret" :rules="ruleSecret" :label-width="100">
              <Form-item label="密保问题" prop="secret" v-if="current == 1">
                <Input type="text" v-model="formSecret.secret" number></Input>
                <span class="tips"></span>
              </Form-item>
            </Form>
            <div style="margin-left: 30px;">
              <Button type="success" @click="loginSubmit()">下一步</Button>
              <Button @click="cancel('isSubpwd')" style="margin-left: 8px">取消</Button>
            </div>
            </Form>
            </Col>
          </Row>
        </div>
        <div class="card" v-if="i.type == 5">
          <Table :columns="i.columns" :data="i.data"></Table>
        </div>
      </div>
    </div>
    <Modal v-model="isModal" :title="cardStep == 0 ? '请输入18位验证码' : '添加学习卡'">
      <div class="modal-step1" v-if="cardStep == 0">
        <input maxlength='6' type='text' />——
        <input maxlength='6' type='text' />——
        <input maxlength='6' type='text' />
      </div>
      <div class="modal-step2" v-if="cardStep == 1">
        <div>
          <p>学习卡编码:</p><input type='text' />
        </div>
        <div>
          <p>激活时间:</p>
          <Date-picker type="date" placeholder="选择日期" style="width: 200px"></Date-picker>
        </div>
        <div>
          <p>过期时间:</p>
          <Date-picker type="date" placeholder="选择日期" style="width: 200px"></Date-picker>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="modalOk">{{ cardStep == 0 ? '点击验证' : '确认添加' }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {
    validatePass,
    validateOld,
    validateQuestion,
    validateSecret,
  } from "../../utils/base.js"
  import ImageCompressor from "image-compressor.js"
  export default {
    props: {
      msgData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      const validateOldPass = (rule, value, callback) => {
        if (value === "") {
          return callback(new Error("请输入原密码"))
        } else {
          return callback()
        }
      }
      const validatePassCheck = (rule, value, callback) => {
        if (value === "") {
          return callback(new Error("请再次输入密码"))
        } else if (value !== this.formCustom.passwd) {
          return callback(new Error("两次输入密码不一致!"))
        } else {
          return callback()
        }
      }
      return {
        isEdit: true, // 可否编辑
        isEditNew: true,
        isPwd: false, // 密码管理
        isSubpwd: false, // 密保设置
        isModal: false, // 添加学习卡的modal框
        current: 0, // 密保设置状态 0 为 登录验证  1 为密保问题设置
        cardStep: 0, // 我的学习卡步骤 0 为输入18位验证码 1 为添加学习卡
        upConfig: {
          action: `${process.env.VUE_APP_SERVER_DOMAIN}/mock/1072/admin/tool/uploadImage`, // 图片上传地址
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          weixinUploadList: [],
          payforUploadList: [],
        },

        campus_nameArr: [],

        // 后台提交时需要的完整数据
        subData: {
          real_name: "",
          email: "",
          area: "",
          province_id: "",
          city_id: "",
          area_id: "",
          campus_id: "",
          // grade_ids: "",
          // subject_ids: "",
          // curse_ids: "",
          wechat: "",
          wx_pic: "",
          alipay: "",
          alipay_pic: "",
          bank_no: "",
          bank_name: "",
        },
        formSecret: {
          secret: "",
        },
        ruleSecret: {
          secret: {
            validator: validateSecret,
            trigger: "blur",
          },
        },
        formQestion: {
          subPwd: "",
        },
        ruleQestion: {
          subPwd: [
            {
              validator: validateQuestion,
              trigger: "blur",
            },
          ],
        },
        formCustom: {
          old_password: "",
          passwd: "",
          passwdCheck: "",
          // old: "",
        },
        ruleCustom: {
          old_password: [
            {
              validator: validateOldPass,
              trigger: "blur",
            },
          ],
          passwd: [
            {
              validator: validatePass,
              trigger: "blur",
            },
          ],
          passwdCheck: [
            {
              validator: validatePassCheck,
              trigger: "blur",
            },
          ],
          // old: [
          //   {
          //     validator: validateOld,
          //     trigger: "blur",
          //   },
          // ],
        },
      }
    },
    filters: {
      typeStyle(type) {
        if (type === 1) {
          return {
            fontSize: "18px",
          }
        }
      },
    },
    components: {},
    mounted() {
      this.getInfo()
      //  this.getcampus_name()
      this.$nextTick(function () {
        let [wx, px] = [
          this.msgData[0].detail.wx_pic,
          this.msgData[0].detail.alipay_pic,
        ]
        if (wx) {
          this.upConfig.weixinUploadList.push({ url: wx, name: "" })
        }
        if (px) {
          this.upConfig.payforUploadList.push({ url: px, name: "" })
        }
      })
    },
    computed: {},
    methods: {
      // 省份选择触发事件
      getCity(val) {
        this.$axios
          .get(`/app/region/getCity?province_id=${val}`)
          .then((res) => {
            this.msgData[0].detail.cityList = res.data
            this.msgData[0].detail.province_id = val
            this.getcampus_name()
          })
      },
      // 城市选择触发事件
      getArea(val) {
        this.$axios.get(`/app/region/getArea?area_id=${val}`).then((res) => {
          this.msgData[0].detail.areaList = res.data
          this.msgData[0].detail.city_id = val
          this.getcampus_name()
        })
      },
      getcampus_name() {
        var a = this.msgData[0].detail.province_id
        var b = this.msgData[0].detail.city_id
        var c = this.msgData[0].detail.area_id
        this.$axios
          .postUp(
            "/app/auth/getCampus?province_id=" +
            a +
            "&city_id=" +
            b +
            "&area_id=" +
            c
          )
          .then((res) => {
            if (res.code == 1) {
              this.campus_nameArr = res.data
            }
          })
      },
      // 区域选择触发事件
      selectArea(val) {
        this.msgData[0].detail.area_id = val
        this.getcampus_name()
      },
      handleRemove(type) {
        // 从 upload 实例删除数据
        this.upConfig[type] = []
      },
      beforeUpload(file) {
        let _th = this
        new ImageCompressor(file, {
          quality: 0.3,
          success(res) {
            res = new File([res], res.name, {
              type: res.type,
              lastModified: Date.now(),
            })
            _th.upLoad(1, res, 1)
          },
        })
      },
      beforeUpload1(file) {
        let _th = this
        new ImageCompressor(file, {
          quality: 0.3,
          success(res) {
            res = new File([res], res.name, {
              type: res.type,
              lastModified: Date.now(),
            })
            _th.upLoad(1, res, 2)
          },
        })
      },
      upLoad(eve, file, type) {
        let formData = new FormData()
        formData.append("file", file)
        this.$axios.postUp("/app/tool/uploadImage", formData).then((res) => {
          if (res.code == 1) {
            if (type == 1) {
              this.upConfig.weixinUploadList = []
              this.upConfig.weixinUploadList.push({
                url: res.data,
                name: file.name,
              })
            }
            if (type == 2) {
              this.upConfig.payforUploadList = []
              this.upConfig.payforUploadList.push({
                url: res.data,
                name: file.name,
              })
            }
          } else {
          }
        })
        return false
      },
      // 保存前重置数据格式
      setInfo() {
        let data = this.msgData[0].detail
        // 全部遍历
        Object.keys(this.subData).forEach((key) => {
          if (data[key]) {
            this.subData[key] = data[key]
          }
        })
        // 微信与支付宝支付码单独赋值
        console.log(this.upConfig.weixinrUploadList)
        if (this.upConfig.weixinUploadList[0])
          this.subData.wx_pic = this.upConfig.weixinUploadList[0].url
        if (this.upConfig.payforUploadList[0])
          this.subData.alipay_pic = this.upConfig.payforUploadList[0].url

        // 级别，科目，课程 单独赋值
        // this.subData.grade_ids = data.gradeArr.toString();
        // this.subData.curse_ids = data.curseArr.toString();
        // this.subData.subject_ids = data.subjectArr.toString();
        return this.subData
      },
      // 设置个人信息
      getInfo() {
        this.$axios.get("/app/student/getInfo").then((res) => {
          if (res.code == 1) {
            console.log(res.data)
            res.data.campus_id = Number(res.data.campus_id)
            this.$store.commit("setUserInfo", res.data)
            // this.$Message.success("保存成功");
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      // 编辑与保存
      edit(i) {
        if (this.isEditNew) {
          this.isEditNew = false
          i.oppear = "保存"
        } else {
          // 表单验证
          let mailReg =
            /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
          let phone = /^[0-9]{11}$/
          if (!mailReg.test(i.detail.email)) {
            this.$Message.warning("请输入正确的邮箱格式")
          }
          // else if (!phone.test(i.detail.mobile)) {
          //   this.$Message.warning("请输入正确的手机号格式");
          // }
          else {
            this.$axios
              .post("/app/student/setInfo", this.setInfo())
              .then((res) => {
                if (res.code == 1) {
                  this.$Message.success("保存成功")
                  this.getInfo()
                  this.isEdit = true
                  i.oppear = "编辑"
                }
              })
          }
        }
      },
      // 学习进度卡，暂无此功能，先保留
      modalOk() {
        // dom操作添加学习卡的交互
        if (this.cardStep == 0) {
          let doms = document.querySelectorAll(".modal-step1 input")
          doms.forEach((ele) => {
            if (!ele.value || ele.value.length < 6) {
              ele.value = null
              ele.setAttribute("placeHolder", "请输入6位验证码")
            } else {
              this.cardStep = 1
            }
          })
        } else {
          let doms = document.querySelectorAll(".modal-step2 input")
          doms.forEach((ele) => {
            if (!ele.value) {
              ele.setAttribute("placeHolder", "请输入")
            } else {
              this.cardStep = 1
            }
          })
        }
      },
      // 更换密码折叠筐
      changePwd() {
        this.isPwd = true
      },
      // 取消折叠筐
      cancel(obj) {
        this[obj] = false
      },
      // 操作按钮全局
      oppear(i) {
        switch (i.type) {
          case 1:
            this.edit(i)
            break
          case 2:
            break
          case 3:
            this.changePwd(i)
            break
          case 4:
            this.isSubpwd = true
            break
          case 5:
            this.isModal = true
            break
        }
      },
      //  修改密码
      pwdSubmit(name) {
        this.$refs[name][0].validate((valid) => {
          if (valid) {
            let params = {
              old_password: this.formCustom.old_password,
              password: this.formCustom.passwd,
              sec_password: this.formCustom.passwdCheck,
            }
            this.$axios.post("/app/student/resetPassword", params).then((res) => {
              if (res.code == 0) {
                this.$Message.warning(res.msg)
              }
              if (res.code == 1) {
                this.$Message.success("修改成功")
                setTimeout(() => {
                  this.cancel("isPwd")
                }, 1000)
              }
            })
          }
        })
      },
      // 密保问题 暂无此功能
      loginSubmit() {
        let name = this.current == 0 ? "formQestion" : "formSecret"
        this.$refs[name][0].validate((valid) => {
          if (valid) {
            this.$Message.success("提交成功!")
            setTimeout(() => {
              if (this.current == 1) {
                this.isSubpwd = false
              }
              this.current = 1
            }, 1000)
          } else {
            this.$Message.error("表单验证失败!")
          }
        })
      },
    },
  }
</script>
<style scoped lang="less">
  .demo-upload-list {
    img {
      width: 100px;
    }
  }
  .uploadimg {
    margin-left: -135px;
  }
  /deep/ .ivu-form-item-content {
    display: flex;
    .tips {
      width: 600px;
      margin-left: 10px;
      color: rgb(117, 117, 117);
    }
  }
  .wrappers {
    height: 70vh;
    overflow: auto;
  }
  .modal-wapper {
    input {
      width: 150px;
    }
  }
  .modal-step1,
  .modal-step2 {
    width: 85%;
    margin: 0 auto;
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      color: rgb(148, 91, 91);
      padding-left: 10px;
    }
  }
  .modal-step2 {
    div {
      margin-top: 10px;
      p {
        width: 100px;
        display: inline-block;
      }
    }
  }
  .box {
    position: relative;
    // width: 90%;
    border: 1px solid #eee;
    border-radius: 5px;
    font-size: 14px;
    // margin: 0 auto;
    border: 1px solid #ddd;
    margin-top: 15px;
    border-radius: 3px;
    .header {
      // position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 10px;
      background: #eee;
      border-bottom: 1px solid #ddd;
      .left {
        width: 60%;
        i {
          width: 25px;
          height: 25px;
          line-height: 25px;
          color: #fff;
          border-radius: 12.5px;
          background: rgb(13, 165, 69);
        }
      }
      .center {
        display: flex;
        font-weight: bold;
        div {
          margin-left: 10px;
        }
      }
      // .right {
      //   position: absolute;
      //   top: 5px;
      //   right: 10px;
      // }
    }
    .detail {
      position: relative;
      height: auto;
      width: 100%;
      background: #fff;
      .edit {
        width: 100%;
        div {
          display: inline-block;
          width: 50%;
          margin-top: 10px;
          span {
            display: inline-block;
            width: 110px;
          }
        }
        padding: 5px;
        i {
          color: #fff;
        }
      }
      .pwd {
        padding: 20px;
      }
      .join {
        padding-left: 20px;
      }
    }
  }
</style>
